export function setBranchofficeWarehouses(state, branchoffice_warehouses){
    state.branchoffice_warehouses = branchoffice_warehouses;
}



// WEBPACK FOOTER //
// ./src/modules/branchoffices-warehouses/mutations.js